import ApiService from './../services/ApiService.js';

let $_courses = [];

export default {
	getAll(refresh = false) {
		return new Promise((resolve, reject) => {
			if ($_courses.length > 0 && !refresh) return resolve($_courses);
			ApiService.getCourses().then(({data}) => {
				$_courses = data.data;
				return resolve($_courses);
			}).catch(e => reject(e))
		});

	}
}
